export enum actionTypes {
  SIGN_UP_FETCH = 'SIGN_UP_FETCH',
  SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS',
  SIGN_UP_ERROR = 'SIGN_UP_ERROR',
  SIGN_UP_RESET = 'SIGN_UP_RESET',
}

export enum SignUpStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface SignUpRequestDto {
  signUpMethod: string
  email: string
}

export interface SignUpState {
  status: SignUpStatus
  signUpMethod: string | null
  email: string | null
  errorCause: string | null
  empresaId: number | null
}

export interface SignUpFetch {
  type: typeof actionTypes.SIGN_UP_FETCH
  payload: SignUpRequestDto
}

export interface SignUpSuccess {
  type: typeof actionTypes.SIGN_UP_SUCCESS
  payload: { empresaId }
}

export interface SignUpError {
  type: typeof actionTypes.SIGN_UP_ERROR
  payload: { errorCause }
}

export interface SignUpReset {
  type: typeof actionTypes.SIGN_UP_RESET
  payload: null
}

export type SignUpActions = SignUpFetch | SignUpSuccess | SignUpError | SignUpReset

export const initialState: SignUpState = {
  status: SignUpStatus.Idle,
  signUpMethod: null,
  email: null,
  errorCause: null,
  empresaId: null,
}
